import { _get, _post } from "../../Api";
import { toast } from "react-toastify";
import { setMerchant } from "../../store/CloudActions";
import cloudStore from "../../store/CloudStore";

export function updatePos(posObject, posType, pos) {
  let data = { ...posObject, ...pos };

  const url =
    posType === "GASTROFIX"
      ? `/nova/v2/${posType.toLowerCase()}_merchants/updatev2`
      : `/nova/v2/${posType.toLowerCase()}_merchants/update`;

  return _post(url, [data])
    .catch((err) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
      return Promise.reject();
    })
    .then((res) => {
      res.data.map((merchant) => {
        let updatedMerchant = { ...cloudStore.merchant };
        if (pos["merchant_id"] != null) {
          updatedMerchant.merchantable = {};
        }
        Object.keys(merchant).forEach((field) => {
          updatedMerchant.merchantable[field] = merchant[field];
          updatedMerchant.merchantable_type = posType;
        });

        setMerchant(updatedMerchant);
      });

      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
      return Promise.resolve(res.data);
    });
}

export function updateSetupPos(posObject, lightspeedMerchantId) {
  return _post(`/nova/v2/lightspeed_merchants/${lightspeedMerchantId}/setupcustomer`, posObject)
    .catch((err) => {
      const errorMessage =
        err.response.data.message != null ? JSON.parse(err.response.data.message).description : "something went wrong";
      toast.error(errorMessage, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
      return Promise.reject();
    })
    .then((res) => {
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });

      let newMerchant = {
        ...cloudStore.merchant
      };

      newMerchant.merchantable = { ...newMerchant.merchantable };

      newMerchant.merchantable.pillar_receipt_customer_id = res.data.pillar_receipt_customer_id;
      newMerchant.merchantable.ta_receipt_customer_id = res.data.ta_receipt_customer_id;
      newMerchant.merchantable.sp_receipt_customer_id = res.data.sp_receipt_customer_id;

      setMerchant(newMerchant);
      return Promise.resolve(res.data);
    });
}

export function getBusinessUnitsPos(merchantableId) {
  return _get(`/nova/v2/ikentoo_merchants/${merchantableId}/businesslocations`)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
      return Promise.reject();
    })
    .then((res) => {
      if (res.data.error) {
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
        // return Promise.reject();
        return null;
      }
      let businessLocations = [];
      res.data.map((merchant) =>
        merchant.businessLocations.forEach((location) => {
          location.name = merchant.name + " - " + location.name;
          businessLocations.push(location);
        })
      );
      return Promise.resolve(businessLocations);
    });
}

export function getUntillSalesareas(merchantableId) {
  return _get(`/nova/v2/untill_merchants/${merchantableId}/salesareas`)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
      return Promise.reject();
    })
    .then((res) => {
      if (res.data.error) {
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
        // return Promise.reject();
        return null;
      }

      const salesareas = res.data.SalesAreas.map((salesarea) => {
          salesarea.id = salesarea.SalesAreaId;
          salesarea.name = salesarea.SalesAreaName + " - " + salesarea.SalesAreaId;
          return salesarea;
        }
      );
      return Promise.resolve(salesareas);
    });
}

export function getMplusTerminals(merchantableId) {
  return _get(`/nova/v2/mplus_merchants/${merchantableId}/terminals`)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
      return Promise.reject();
    })
    .then((res) => {
      if (res.data.error) {
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
        // return Promise.reject();
        return null;
      }

      res.data.forEach((terminal) => {
          terminal.id = terminal.terminalNumber;
          terminal.name = terminal.branchName + "-" + terminal.terminalNumber + "-" + terminal.terminalName;
        }
      );
      return Promise.resolve(res.data);
    });
}

export function getMplusFinancialBranches(merchantableId) {
  return _get(`/nova/v2/mplus_merchants/${merchantableId}/financialBranches`)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
      return Promise.reject();
    })
    .then((res) => {
      if (res.data.error) {
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
        // return Promise.reject();
        return null;
      }

      res.data.map((branch) => {
          branch.id = branch.branchNumber;
          branch.name = branch.branchNumber + "-" + branch.branchName;
        }
      );
      return Promise.resolve(res.data);
    });
}
export function getMplusEmployees(merchantableId) {
  return _get(`/nova/v2/mplus_merchants/${merchantableId}/employees`)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
      return Promise.reject();
    })
    .then((res) => {
      if (res.data.error) {
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
        // return Promise.reject();
        return null;
      }

      res.data.map((item) => {
          item.id = item.employeeNumber;
          item.name = item.employeeNumber + "-" + item.name;
        }
      );
      return Promise.resolve(res.data);
    });
}

export function getMenusPos(posType, merchantableId) {
  return _get(`/nova/v2/${posType}_merchants/${merchantableId}/menus`)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
      return Promise.reject();
    })
    .then((res) => {
      if (res.data.error) {
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
        // return Promise.reject();
        return null;
      }

      let menus = [];
      res.data.map((object) => {
        menus.push({ name: object.menuName, id: object.ikentooMenuId });
      });

      return Promise.resolve(menus);
    });
}

export function getPaymentMethodsPos(posType, merchantableId) {
  return _get(`/nova/v2/${posType}_merchants/${merchantableId}/paymentMethods`)
    .catch((e) => {
      // toast.error("Something went wrong.", {
      //   position: "bottom-right",
      //   autoClose: 2000,
      //   hideProgressBar: true,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });
      return Promise.reject();
    })
    .then((res) => {
      if (res.data.error) {
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
        // return Promise.reject();
        return null;
      }

      if (res.data._embedded) {
        let paymentMethodList = [];
        res.data._embedded.paymentMethodList.map((object) => {
          paymentMethodList.push({ ...object, name: object.name, id: object.code });
        });
        return Promise.resolve(paymentMethodList);
      } else {
        if (res.data.errorMessage || (res.data.result && res.data.result?.status_code != 200)) {
          return Promise.resolve([{ id: 0, name: "no results" }]);
        } else {
          if (res.data.paymentMethods != null) {
            return Promise.resolve(res.data.paymentMethods);
          }
          return Promise.resolve(res.data);
        }
      }
    });
}

export function getWaiters(posType, merchantableId) {
  return _get(`/nova/v2/gastrofix_merchants/${merchantableId}/waiters`)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
      return Promise.reject();
    })
    .then((res) => {
      if (res.data.error) {
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
        // return Promise.reject();
        return null;
      }

      let employees = [];

      if (res.data.employees != null) {
        res.data.employees.map((object) => {
          employees.push({ ...object, name: `${object.firstName} ${object.lastName} - id: ${object.id}` });
        });
        return Promise.resolve(employees);
      } else {
        return Promise.resolve([{ id: 0, name: "no results" }]);
      }
    });
}
